export enum SellerFiltersType {
  Active = 'active',
  Reserved = 'reserved',
  Drafts = 'draft',
  Sold = 'sold',
  Hidden = 'hidden',
}
